import { Vue, Component, Prop, Emit, Watch, Inject } from 'vue-property-decorator'
import { notificationTypeServices } from '@/modules/configurationModule/detail/notifications/services/notification-type-services'
import {
    initialNotificationTypesModalBasicDataForm, NotificationTypesModalBasicData,
    NotificationTypesModalBasicDataForm
} from '@/modules/configurationModule/detail/notifications/components/notification-types-modal-basic-data-form/basic-data-form.model'
import { cloneDeep } from 'lodash'

@Component({
    components: {}
})
export default class BasicDataForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() basicData!: NotificationTypesModalBasicDataForm
    @Prop(Boolean) isGlobal!: boolean
    @Prop({ default: null }) notificationTypeId!: number
    @Inject() externalValidator!: any
    @Emit()
    update(basicData: NotificationTypesModalBasicDataForm): NotificationTypesModalBasicDataForm {
        return basicData
    }
    @Emit()
    create(basicData: NotificationTypesModalBasicDataForm): NotificationTypesModalBasicDataForm {
        return basicData
    }
    @Watch('basicData', { deep: true })
    onPropertyChanged(value: NotificationTypesModalBasicData) {
        this.state.basicData = cloneDeep(value)
    }

    private state: NotificationTypesModalBasicDataForm
    constructor() {
        super()
        this.state = initialNotificationTypesModalBasicDataForm()
        this.$validator = this.externalValidator
    }

    async getAllNotificationTypes() {
        const [error, response] = await this.$_toCall(notificationTypeServices.getAllNotificationTypes(this.isGlobal))
        if (error) {
            this.$_showErrorModalFromErrorResponse(error)
            return false
        }
        return response
    }

    get canUpdateOrCreate(): boolean {
        return Object.keys(this.fields).some((key: any) => {
            return this.fields?.[key]?.dirty
        })
    }

    get notificationTypesComboDisabled(): boolean {
        return !!this.notificationTypeId
    }

    get modelValidated(): boolean {
        let hasSelectedNotificationType = !this.$_isEmpty(this.state.basicData.notificationType)
        const hasErrors = !!this.errors.count()
        return this.canUpdateOrCreate && !hasErrors && hasSelectedNotificationType
    }

    actionModal() {
        if (this.notificationTypeId) {
            this.update(this.state)
        } else {
            this.create(this.state)
        }
    }
}
